// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { urlLinksResponseSchema } from '@/url-link/api/types';

/**
 * Retrieves all URL links associated with a specific asset.
 * This function handles the API call to fetch URL link metadata and validates
 * the response data using Zod schemas.
 *
 * @param key - Unique identifier of the asset to fetch URL links for
 * @returns Promise resolving to the list of URL links and request metadata
 * @throws Will throw an error if the API request fails or if the response data is invalid
 */
export async function getAssetURLLinks(key: string) {
  const path = `/v1/asset/${key}/url-link`;
  const response = await api.get(path);

  return parseResponse(urlLinksResponseSchema, response.data, {
    schemaName: 'AssetURLLinks',
    endpoint: path,
  });
}
